"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_dom_1 = require("react-dom");
const App_1 = require("./components/App");
const AppContext_1 = require("./contexts/AppContext");
require("./lib/i18n");
react_dom_1.render(react_1.default.createElement(AppContext_1.AppContextProvider, null,
    react_1.default.createElement(App_1.App, null)), document.getElementById('root'));
// document.addEventListener('keydown', function(ev) {
// 	if (ev.key === 'Control') {
// 		store.debug = true;
// 	}
// });
//
// document.addEventListener('keyup', function(ev) {
// 	if (ev.key === 'Control') {
// 		store.debug = false;
// 	}
// });
